import Linkify from 'linkify-react';

import classNames from 'classnames/bind';
import { Typography } from 'shared';

import { useChatMessageContext } from 'features/chat/context/chatMessage';

import { extractDomainName, extractLinksFromString } from 'shared/utils/links';

import styles from 'features/chat/components/Chat.module.css';

type TChatMessageText = {
  text: string;
  isLinkPreviewPresent: boolean;
};

const MAX_LINK_TEXT_LENGTH = 100;

const cx = classNames.bind(styles);

export const ChatMessageText = ({
  text,
  isLinkPreviewPresent,
}: TChatMessageText) => {
  const { isIncoming } = useChatMessageContext();

  return (
    <Typography
      type="body"
      color={isIncoming ? 'blackTotal' : 'whiteTotal'}
      wordBreak="break-word"
      whiteSpace="pre-wrap"
      textAlign="left"
      dataTestid="chat-message-text"
    >
      <Linkify
        options={{
          target: '_blank',
          className: cx('chat__link'),
          format: linkFormatter,
        }}
      >
        {formatMessageTextForLinkPreview({
          text,
          isLinkPreviewPresent,
        })}
      </Linkify>
    </Typography>
  );
};

export const formatMessageTextForLinkPreview = ({
  text,
  isLinkPreviewPresent,
}: {
  text: string;
  isLinkPreviewPresent: boolean;
}) => {
  let messageText = text;

  const links = extractLinksFromString(text);

  const isTextExclusivelyLink =
    links.length === 1 && links[0].length === text.length;

  if (isTextExclusivelyLink && isLinkPreviewPresent) {
    messageText = '';
  }

  return messageText;
};

const linkFormatter = (link: string) => {
  if (link.length < MAX_LINK_TEXT_LENGTH) {
    return link;
  }

  return extractDomainName(link);
};
